import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';

export default function CategoryPreview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="categories-heading">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 id="categories-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              漫画分类
            </h2>
            <p className="text-sm text-foreground-500">探索不同类型的韩国漫画，发现你的最爱</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => {
            const catComics = comics.filter((c) => c.category === cat.id);
            const previewComic = catComics[0];
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02]"
              >
                <div className="relative h-32 overflow-hidden">
                  {previewComic && (
                    <img
                      src={previewComic.cover}
                      alt={`${cat.name} - 韩国漫画分类`}
                      className="w-full h-full object-cover object-top opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-500"
                      loading="lazy"
                    />
                  )}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 transition-colors duration-300">
                      <i className={`${cat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-white transition-colors duration-300`}></i>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-medium text-foreground-900 text-sm md:text-base group-hover:text-primary-600 transition-colors duration-200">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                    {cat.description}
                  </p>
                  <span className="inline-block mt-2 text-[11px] text-primary-500">
                    {catComics.length}部作品
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}